var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg"},[_c('div',{staticClass:"error"},[_c('p',[_vm._v("很抱歉！您所访问的页面未能找到或者出现了未知错误....")]),_vm._v(" "),_c('router-link',{staticClass:"error-btn",attrs:{"to":'/'}},[_vm._v("返回首页")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-0d66394b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/Error404.vue
// module id = null
// module chunks = 